import $ from 'jquery';
import run from '../../utilities/run';
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";

run("#return-disposition-rule-details-page", ()=>{
  const returnDispRuleDetailsPage = $("#return-disposition-rule-details-page");
  const activeRuleBtn = returnDispRuleDetailsPage.find(".activate-rule-btn");
  const inActiveRuleBtn = returnDispRuleDetailsPage.find(".deactivate-rule-btn");
  const activateUrl = returnDispRuleDetailsPage.data("activate-rule-url");
  const inactivateUrl = returnDispRuleDetailsPage.data("inactivate-rule-url");
  const detailPageUrl = returnDispRuleDetailsPage.data("detail-url");
  const duplicateRuleUrl = returnDispRuleDetailsPage.data("duplicate-rule-url");
  
  $("body").on("click", "#duplicate-btn", function (e) {
        window.location.href = duplicateRuleUrl + "&isDuplicate=true";
  });
	
  $(activeRuleBtn).on("click", function(e){
		e.preventDefault();
		activateRuleModal.showConfirmModal();
	});
	 
  $(inActiveRuleBtn).on("click", function(e){
		e.preventDefault();
		deactivateRuleModal.showConfirmModal();
	});
	
	const  deactivateRuleModal = new SubmitModalFlow({
      confirmModalTitle: 'Deactivate Rule',
      confirmModalBody: '<div class="q-pad-all-xl">Once deactivated, this rule will no longer be checking any product attributes. It can be activated at any time.</div>',
      confirmModalBtnText: 'Deactivate Rule',
      modalDialogClass: "q-modal-dialog-500",
      onConfirmClick: function () {
        // Show Loading Modal
        deactivateRuleModal.showLoadingModal();
		$.ajax({
          url: inactivateUrl,
          dataType:"JSON",
          type: 'POST',
          success: onSuccessInactivate,
          error: onErrorInactivate
        });
        function onSuccessInactivate() {
          deactivateRuleModal.showSuccessModal();
          setTimeout(function() {
            location.href = detailPageUrl;
          }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
        }

        function onErrorInactivate() {
          deactivateRuleModal.hideAllModals();
        }
      }
    });

    deactivateRuleModal.init();

    const activateRuleModal = new SubmitModalFlow({
      confirmModalTitle: 'Activate Rule',
      confirmModalBody: '<div class="q-pad-all-xl">Once activated, this rule will begin checking any product attributes. It can be deactivated at any time.</div>',
      confirmModalBtnText: 'Activate Rule',
      modalDialogClass: "q-modal-dialog-500",
      onConfirmClick: function () {
        // Show Loading Modal
        activateRuleModal.showLoadingModal();
        $.ajax({
          url: activateUrl,
          dataType:"JSON",
          type: 'POST',
          success: onSuccessActivate,
          error: onErrorActivate
        });
		
		function onSuccessActivate() {
          activateRuleModal.showSuccessModal();
          setTimeout(function() {
            location.href = detailPageUrl;
          }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
        }

        function onErrorActivate() {
          activateRuleModal.hideAllModals();
        }
      }
    });

    activateRuleModal.init();

});


// WEBPACK FOOTER //
// ./src/pages/returnDispositionDetails/returnDispositionRuleDetailsPage.js